"use client";

import Link from "next/link";
import Image from "next/image";
import {
  FileText,
  Headset,
  MailPlus,
  MailX,
} from "lucide-react";
import { usePathname } from "next/navigation";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

export default function LegalLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const pathname = usePathname();

  return (
    <>
      <header className="flex justify-center py-15">
        <Link href="/" className="flex items-center gap-2 text-xl font-bold">
          <Image src="/images/logo.svg" alt="Logo" width={42} height={42} />
          <span>Telephony Voice AI Agent</span>
        </Link>
      </header>
      <div className="container mx-auto flex flex-col lg:flex-row flex-1 p-4 gap-10 lg:gap-12">
        <aside className="w-full lg:w-1/4 lg:pl-8 lg:sticky top-24 h-fit transition-all duration-300">
          <nav className="flex flex-col space-y-2 bg-blue-50 p-5 rounded-md border-[2px] border-blue-300">
            <div className="text-lg font-semibold px-3 pb-3">My Requests</div>
            <Link href="/form/get-a-proposal"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/form/get-a-proposal"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}>
              <FileText size={20} />
              Get a Proposal
            </Link>
            <Link href="/form/support"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/form/support"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}>
              <Headset size={20} />
              Help & Support
            </Link>
            <Separator />
            <div className="text-lg font-semibold p-3">Newsletters</div>
            <Link href="/form/newsletter-join"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/form/newsletter-join"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}>
              <MailPlus size={20} />
              Join
            </Link>
            <Link href="/form/newsletter-leave"
              className={cn(
                "flex items-center gap-3 hover:text-primary hover:bg-white p-4 rounded-md",
                pathname === "/form/newsletter-leave"
                  ? "bg-white text-primary"
                  : "text-gray-800"
              )}>
              <MailX size={20} />
              Leave
            </Link>
          </nav>
        </aside>
        <main className="w-full lg:w-3/4 order-1 lg:order-2 mb-10 p-6 border border-blue-300 bg-white rounded-lg shadow-sm">{children}</main>
      </div>
    </>
  );
}